import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { MaterialUIControllerProvider } from "context";
import { ProfileProvider } from "context/profileContext";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { handleAppUpdate } from "utils/appUpdate";

const container = document.getElementById("app");
if (!container) {
  console.error('No root container found (expected <div id="app"> in public/index.html)');
} else {
  const root = createRoot(container);
  const isMaintenance =
    process.env.REACT_APP_MAINTENANCE === "1" || process.env.REACT_APP_MAINTENANCE === "true";

  if (isMaintenance) {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .getRegistrations()
        .then((regs) => regs.forEach((r) => r.unregister()))
        .catch(() => {});
    }
    import("components/MaintenancePage").then(({ default: MaintenancePage }) => {
      root.render(<MaintenancePage />);
    });
  } else {
    root.render(
      <BrowserRouter>
        <MaterialUIControllerProvider>
          <ProfileProvider>
            <App />
          </ProfileProvider>
        </MaterialUIControllerProvider>
      </BrowserRouter>,
    );
  }
}

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      // Reload once the new SW takes control, unless that would discard unsaved work
      navigator.serviceWorker.addEventListener("controllerchange", handleAppUpdate, {
        once: true,
      });
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  },
});
